import axios from 'axios'
import {Dispatch, FC, ReactNode, SetStateAction, useEffect, useState} from 'react'
import {useParams} from 'react-router-dom'
import {API_URL, GetBrowserData} from '../../../../_metronic/helpers'
import {ListLoading} from '../../../../_metronic/helpers/components/ListLoading'
import {CustomInputs} from '../../../../_metronic/helpers/components/CustomInputs'
import {LoginMobile} from '../../auth/components/LoginMobile'

type props = {
  successFn: () => void
  setMobile: Dispatch<SetStateAction<string>>
}

const Login: FC<props> = ({successFn, setMobile}) => {
  useEffect(() => {}, [])

  return (
    <>
      <LoginMobile simpleMode successFn={successFn} setMobile={setMobile} />
    </>
  )
}

export {Login}
